import React, { useEffect, useState } from "react";

const Vehicledocuments = ({ summaryDetails }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const resourceTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.resourceTypes;
  const [documents, setDocuments] = useState([]);

  const getVehicleDocuments = async (value) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/documents?limit=100&resourceType=${resourceTypes?.inverted?.vehicles}&resourceId=${summaryDetails?.vehicleId}&isReminderSet=${true}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setDocuments(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  useEffect(() => {
    if (summaryDetails?.vehicleId) {
      getVehicleDocuments();
    }
  }, [summaryDetails?.vehicleId]);

  return (
    <div className="p-4">
      {documents?.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead className="bg-gray-100">
              <tr>
                <th className="border px-4 py-2 text-left">Document Type</th>
                <th className="border px-4 py-2 text-left">Name</th>
                <th className="border px-4 py-2 text-left">Attachment</th>
                <th className="border px-4 py-2 text-left">Valid From</th>
                <th className="border px-4 py-2 text-left">Valid To</th>
              </tr>
            </thead>

            <tbody>
              {documents.map((doc) => {
                const attachments = doc?.attachments
                  ? JSON.parse(doc.attachments)
                  : [];

                return (
                  <tr key={doc?.id}>
                    <td className="border px-4 py-2">
                      {doc?.documentTypeDetails || "-"}
                    </td>

                    <td className="border px-4 py-2">{doc?.name || "-"}</td>

                    <td className="border px-4 py-2">
                      {attachments.length > 0
                        ? attachments.map((file, index) => (
                            <div key={index} className="mb-2">
                              <a
                                href={file?.url}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="bg-blue-500 text-white px-3 py-1 rounded"
                              >
                                Download
                              </a>
                            </div>
                          ))
                        : "-"}
                    </td>

                    <td className="border px-4 py-2">
                      {doc?.startDate
                        ? new Date(doc.startDate).toLocaleDateString()
                        : "-"}
                    </td>

                    <td className="border px-4 py-2">
                      {doc?.endDate
                        ? new Date(doc.endDate).toLocaleDateString()
                        : "-"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No documents found for this vehicle.</p>
      )}
    </div>
  );
};
export default Vehicledocuments;
